import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AppContext from "../../../context/AppContext.js";
import MasterLayout from "../../../layout/superadmin/MasterLayout";
import {
  FiPlus,
  FiMoreVertical,
  FiTrash2,
  FiEdit2,
  FiToggleLeft,
  FiToggleRight,
} from "react-icons/fi";
import Swal from "sweetalert2";
import AppPagination from "../../../components/general/pagination/Pagination.js";
import "../../../assets/css/superadmin/specilizationmanagment/SpecilizationManagment.css";
import { Spinner } from "react-bootstrap";

const SpecilizationManagment = () => {
  const { baseUrl , authToken} = useContext(AppContext);
  const [specializations, setSpecializations] = useState([]);
  const [specializationname, setSpecializationName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [activeMenu, setActiveMenu] = useState(null);
  const [editingSpecialization, setEditingSpecialization] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [idToUpdateDeleteSpecialization, setIDToUpdateDeleteSpecialization] =
    useState("");
  const specializationsPerPage = 5;

const addSpecialization = () => {
  // Validation: agar name khali ho
  if (!specializationname.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Oops!",
      text: "Please enter your data",
      confirmButtonText: "OK",
      confirmButtonColor: "#7c3aed",
    });
    return;
  }

  setButtonLoading(true);
  const formData = new FormData();
  formData.append("specializationname", specializationname);
  axios
    .post(
      `${baseUrl}/superadmin/specialization/addSpecialization`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" ,
          Authorization: `Bearer ${authToken}`
        },
      },
    )
    .then((response) => {
      console.log(response.data);
      viewAllSpecializations();
      setButtonLoading(false);
      resetForm();

      Swal.fire({
        icon: "success",
        title: "Congratulations!",
        text: "Specialization Added successfully",
        confirmButtonText: "Wow",
        confirmButtonColor: "#7c3aed",
      });
    })
    .catch((error) => {
      console.log(error);
      setButtonLoading(false);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong, please try again",
        confirmButtonColor: "#7c3aed",
      });
    });
};

  const updateSpecialization = () => {
  // Validation: agar name khali ho
  if (!specializationname.trim()) {
    Swal.fire({
      icon: "warning",
      title: "Oops!",
      text: "Please enter your data",
      confirmButtonText: "OK",
      confirmButtonColor: "#7c3aed",
    });
    return;
  }

  setButtonLoading(true);
  const formData = new FormData();
  formData.append("id", idToUpdateDeleteSpecialization);
  formData.append("specializationname", specializationname);
  axios
    .post(
      `${baseUrl}/superadmin/specialization/updateSpecialization`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`
         },
      },
    )
    .then((response) => {
      console.log(response.data);
      viewAllSpecializations();
      setButtonLoading(false);
      resetForm();

      Swal.fire({
        icon: "success",
        title: "Congratulations!",
        text: "Specialization Updated successfully",
        confirmButtonText: "Wow",
        confirmButtonColor: "#7c3aed",
      });
    })
    .catch((error) => {
      console.log(error);
      setButtonLoading(false);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong, please try again",
        confirmButtonColor: "#7c3aed",
      });
    });
};

  const viewAllSpecializations = () => {
    axios
      .get(`${baseUrl}/superadmin/specialization/viewAllSpecializations`, {
      headers: { Authorization: `Bearer ${authToken}` }
    })
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data.success && response.data.data) {
          setSpecializations(response.data.data);
        } else {
          setSpecializations([]);
        }
      })
      .catch((error) => {
        console.log(error);
        setSpecializations([]);
      });
  };

  useEffect(() => {
    viewAllSpecializations();
  }, []);

  const deleteSpecialization = (id) => {
    const formData = new FormData();
    formData.append("id", id);
    axios
      .post(
        `${baseUrl}/superadmin/specialization/deleteSpecialization`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`
           },
        },
      )
      .then((response) => {
        console.log(response.data);
        viewAllSpecializations();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const toggleMenu = (id) => {
    setActiveMenu(activeMenu === id ? null : id);
  };

  const toggleStatus = (id, isCurrentlyActive) => {
    console.log("Toggle ID:", id);
    console.log("isCurrentlyActive:", isCurrentlyActive);
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", isCurrentlyActive ? "inactive" : "active");
    axios
      .post(
        `${baseUrl}/superadmin/specialization/updateSpecialization`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`
           },
        },
      )
      .then((response) => {
        console.log("Toggle response:", response.data);
        viewAllSpecializations();
      })
      .catch((error) => {
        console.log("Toggle error:", error);
      });
  };

  const edit = (specialization) => {
    setEditingSpecialization(true);
    setIDToUpdateDeleteSpecialization(specialization.id);
    setSpecializationName(specialization.specializationname);
    setActiveMenu(null);
  };

  const resetForm = () => {
    setEditingSpecialization(false);
    setIDToUpdateDeleteSpecialization("");
    setSpecializationName("");
  };

  // Pagination Logic
  const indexOfLastSpecialization = currentPage * specializationsPerPage;
  const indexOfFirstSpecialization =
    indexOfLastSpecialization - specializationsPerPage;
  const currentSpecializations = specializations.slice(
    indexOfFirstSpecialization,
    indexOfLastSpecialization,
  );
  const totalPages = Math.ceil(specializations.length / specializationsPerPage);

  return (
    <MasterLayout>
      <div className="specmgmt-specialization-management-page">
        <div className="specmgmt-specialization-container">
          {/* Add New Specialization Section */}
          <div className="specmgmt-add-specialization-section">
            <div className="specmgmt-section-header">
              <FiPlus className="specmgmt-header-icon" />
              <h2 className="specmgmt-section-title">
                {editingSpecialization
                  ? "Edit Specialization"
                  : "Add New Specialization"}
              </h2>
            </div>

            <div className="specmgmt-add-specialization-form">
              <div className="specmgmt-form-group">
                <label className="specmgmt-form-label">
                  Specialization Name
                </label>
                <input
                  type="text"
                  className="specmgmt-specialization-input"
                  placeholder="e.g., Tractor Repair"
                  value={specializationname}
                  onChange={(event) =>
                    setSpecializationName(event.target.value)
                  }
                />
              </div>

              <div className="specmgmt-button-group">
                {editingSpecialization && (
                  <button className="specmgmt-cancel-btn" onClick={resetForm}>
                    Cancel
                  </button>
                )}
                <button
                  className="specmgmt-add-specialization-btn"
                  onClick={
                    editingSpecialization
                      ? updateSpecialization
                      : addSpecialization
                  }
                >
                  {/* {buttonlaoding (ye ha state ka name)? ():()} */}
                  {buttonLoading ? (
                    <Spinner />
                  ) : (
                    <>
                      <FiPlus size={20} />
                      {editingSpecialization
                        ? "Update Specialization"
                        : "Add Specialization"}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Existing Specializations Section */}
          <div className="specmgmt-existing-specializations-section">
            <div className="specmgmt-specializations-header">
              <h3 className="specmgmt-specializations-title">
                Existing Specializations
              </h3>
            </div>

            <div className="specmgmt-specializations-table-wrapper">
              <table className="specmgmt-specializations-table">
                <thead>
                  <tr>
                    <th>SPECIALIZATION ID</th>
                    <th>SPECIALIZATION NAME</th>
                    <th>STATUS</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {currentSpecializations.map((specialization) => {
                    // ✅ FIX: database 'status' field = 'active' string
                    const isActive = specialization.status === "active";
                    return (
                      <tr key={specialization.id}>
                        <td className="specmgmt-specialization-id">
                          #{specialization.id}
                        </td>
                        <td className="specmgmt-specialization-name">
                          {specialization.specializationname}
                        </td>
                        <td>
                          <span
                            className={`specmgmt-status-badge ${isActive ? "active" : "disabled"}`}
                          >
                            {isActive ? "Active" : "Disabled"}
                          </span>
                        </td>
                        <td className="specmgmt-specialization-actions">
                          <div className="specmgmt-actions-menu-wrapper">
                            <button
                              className="specmgmt-menu-button"
                              onClick={() => toggleMenu(specialization.id)}
                            >
                              <FiMoreVertical size={20} />
                            </button>

                            {activeMenu === specialization.id && (
                              <div className="specmgmt-dropdown-menu">
                                <button
                                  className="specmgmt-edit-option"
                                  onClick={() => edit(specialization)}
                                >
                                  <FiEdit2 size={16} />
                                  Edit
                                </button>
                                <button
                                  className="specmgmt-toggle-option"
                                  onClick={() => {
                                    // ✅ FIX: isActive pass kar rahe hain
                                    toggleStatus(specialization.id, isActive);
                                    setActiveMenu(null);
                                  }}
                                >
                                  {isActive ? (
                                    <>
                                      <FiToggleLeft size={16} /> Disable
                                    </>
                                  ) : (
                                    <>
                                      <FiToggleRight size={16} /> Enable
                                    </>
                                  )}
                                </button>
                                <button
                                  className="specmgmt-delete-option"
                                  onClick={() =>
                                    deleteSpecialization(specialization.id)
                                  }
                                >
                                  <FiTrash2 size={16} />
                                  Delete
                                </button>
                              </div>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <AppPagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={specializations.length}
              itemsPerPage={specializationsPerPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      </div>
    </MasterLayout>
  );
};

export default SpecilizationManagment;
